import SimpleDailyListContainer from './Simple'
import AffiliateListContainer from './AffiliateList'
import CourseListContainer from './CourseList'
import DailyItemListContainer from './DailyItemList'
import StandardDailyList from 'ui-component-library/components/DailyList/Standard'

type Props = {
  contentType: string
  perPage: number
  orderBy: 'date'
  sort: 'desc'
  noResultsFoundText: string
  loadMoreText: string
  affiliateList: {
    nearMeText: string
    allText: string
    headlineText: string
  }
  courseList: {
    nearMeText: string
    allText: string
    headlineText: string
  }
}

function DailyListContainer(props: Props) {
  const {
    perPage,
    noResultsFoundText,
    affiliateList,
    courseList,
    loadMoreText,
    contentType,
    orderBy,
    sort,
  } = props

  return perPage === 1 ? (
    <SimpleDailyListContainer {...props} />
  ) : (
    <StandardDailyList
      affiliateList={<AffiliateListContainer {...affiliateList} />}
      dailyItemList={
        <DailyItemListContainer
          noResultsFoundText={noResultsFoundText}
          loadMoreText={loadMoreText}
          contentType={contentType}
          perPage={perPage}
          orderBy={orderBy}
          sort={sort}
        />
      }
      courseList={<CourseListContainer {...courseList} />}
    />
  )
}

export default DailyListContainer
